import { render } from "./TheDeviceConfigurationsList.vue?vue&type=template&id=235751bd"
import script from "./TheDeviceConfigurationsList.vue?vue&type=script&lang=js"
export * from "./TheDeviceConfigurationsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__